import axios from 'axios';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    charts : {},
    loaded : false,
    allLoaded : false,
})

  // getters
  const getters = {
  }

  // actions
  const actions = {
    async load({commit, state, rootState}){
        if(state.allLoaded == false){
            commit("loaded", false);
            await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/dashboard/charts").then((response) => {
                commit("set", response.data);
                commit("loaded", true);
            })
        }
    },
  }

  // mutations
  const mutations = {
      clean(state){
        state.list = [];
        state.charts = {};
        state.allLoaded = false;
        state.loaded = false;
      },
      set(state, data){
          state.charts = [];
        state.charts = data;
      },
      loaded(state, status){
          state.loaded = status;
      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
